import React from "react";
import { Zoom } from "react-reveal";

const Client = () => {
  const clientImg1 = [
    "images/cimage1.jpg",
    "images/cimage2.jpg",
    "images/cimage3.jpg",
    "images/cimage4.jpg",
    "images/cimage5.jpg",
    "images/cimage6.jpg",
    "images/cimage7.jpg",
    "images/cimage8.jpg",
    "images/cimage9.jpg",
    "images/cimage10.jpg",
    "images/cimage11.jpg",
    "images/cimage12.jpg",
    "images/cimage13.jpg",
    "images/cimage14.jpg",
    "images/cimage15.jpg",
    "images/cimage16.jpg",
    "images/cimage17.jpg",
    "images/cimage18.jpg",
    "images/cimage19.jpg",
    "images/cimage20.jpg",
    "images/cimage22.jpg",
    "images/cimage23.jpg",
    "images/cimage24.jpg",
    "images/cimage25.jpg",
    "images/cimage26.jpg",
    "images/cimage27.jpg",
    "images/cimage28.jpg",
    "images/cimage29.jpg",
    "images/cimage30.jpg",
    "images/cimage30.jpg",
    "images/cimage31.jpg",
    "images/cimage32.jpg",
    "images/cimage33.jpg",
    "images/cimage34.jpg",
    "images/cimage35.jpg",
    "images/cimage36.jpg",
    "images/cimage37.jpg",
    "images/cimage38.jpg",
    "images/cimage39.jpg",
    "images/cimage40.jpg",
    "images/cimage41.jpg",
    "images/cimage42.jpg",
    "images/cimage43.jpg",
    "images/cimage44.jpg",
    "images/cimage45.jpg",
    "images/cimage46.jpg",
    "images/cimage47.jpg",
    "images/cimage48.jpg",
    "images/cimage49.jpg",
    "images/cimage50.jpg",
    "images/cimage51.jpg",
    "images/cimage52.jpg",
    "images/cimage53.jpg",
    "images/cimage54.jpg",
    "images/cimage55.jpg",
    "images/cimage56.jpg",
    "images/cimage57.jpg",
    "images/cimage58.jpg",
    "images/cimage59.jpg",
    "images/cimage60.jpg",
    "images/cimage61.jpg",
    "images/cimage62.jpg",
    "images/cimage63.jpg",
    "images/cimage64.jpg",
    "images/cimage65.jpg",
    "images/cimage66.jpg",
    "images/cimage67.jpg",
    "images/cimage68.jpg",
  ];
  const clientImg2 = [
    "images/cimage69.jpg",
    "images/cimage70.jpg",
    "images/cimage71.jpg",
    "images/cimage72.jpg",
    "images/cimage73.jpg",
    "images/cimage74.jpg",
    "images/cimage75.jpg",
    "images/cimage76.jpg",
    "images/cimage77.jpg",
    "images/cimage78.jpg",
    "images/cimage79.jpg",
    "images/cimage80.jpg",
    "images/cimage81.jpg",
    "images/cimage82.jpg",
    "images/cimage83.jpg",
    "images/cimage84.jpg",
    "images/cimage85.jpg",
    "images/cimage86.jpg",
    "images/cimage87.jpg",
    "images/cimage88.jpg",
    "images/cimage89.jpg",
    "images/cimage90.jpg",
    "images/cimage91.jpg",
    "images/cimage92.jpg",
    "images/cimage93.jpg",
    "images/cimage94.jpg",
    "images/cimage95.jpg",
    "images/cimage96.jpg",
    "images/cimage97.jpg",
    "images/cimage98.jpg",
    "images/cimage99.jpg",
    "images/cimage100.jpg",
    "images/cimage101.jpg",
    "images/cimage102.jpg",
    "images/cimage103.jpg",
    "images/cimage104.jpg",
    "images/cimage105.jpg",
    "images/cimage106.jpg",
    "images/cimage107.jpg",
    "images/cimage108.jpg",
    "images/cimage109.jpg",
    "images/cimage110.jpg",
    "images/cimage111.jpg",
    "images/cimage112.jpg",
    "images/cimage113.jpg",
    "images/cimage114.jpg",
    "images/cimage115.jpg",
    "images/cimage116.jpg",
    "images/cimage117.jpg",
    "images/cimage118.jpg",
    "images/cimage119.jpg",
    "images/cimage120.jpg",
    "images/cimage121.jpg",
    "images/cimage122.jpg",
    "images/cimage123.jpg",
    "images/cimage124.jpg",
    "images/cimage125.jpg",
    "images/cimage126.jpg",
    "images/cimage127.jpg",
    "images/cimage128.jpg",
    "images/cimage129.jpg",
    "images/cimage130.jpg",
    "images/cimage131.jpg",
    "images/cimage132.jpg",
    "images/cimage133.jpg",
    "images/cimage134.jpg",
    "images/cimage135.jpg",
    "images/cimage136.jpg",
    "images/cimage137.jpg",
    "images/cimage138.jpg",
  ];
  return (
    <div id="Client" className="container-xxl py-4">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            <Zoom left>Client</Zoom>
          </h6>
          <Zoom right>
            <h1 className="mb-5 subtitle">Happiness Share With Them</h1>
          </Zoom>
        </div>
        <div className="marquee-wrapper">
          <div className="pmarquee">
            <marquee behavior="scroll" direction="left" scrollamount="10">
              {clientImg1.map((item, index) => (
                <Zoom>
                  <img
                    src={item}
                    className="brandImag"
                    alt="Natural"
                    key={index}
                  />
                </Zoom>
              ))}
            </marquee>
          </div>
          <div className="pmarquee">
            <marquee behavior="scroll" direction="right" scrollamount="10">
              {clientImg2.map((item, index) => (
                <Zoom>
                  <img
                    src={item}
                    className="brandImag"
                    alt="Natural"
                    key={index}
                  />
                </Zoom>
              ))}
            </marquee>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Client;
